<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '文档', '未命名文档']"></breadcrumb>
    <div class="container" v-loading="publishLoading">
      <div class="form-con">
        <el-form label-position="top" :inline="true">
          <el-row>
            <template v-for="item in fodderData">
              <el-col v-if="(fileType === 0 ? item.pptxShow : item.wordShow) && showCatelog(item)" :span="6"
                :key="item.type">
                <el-form-item :label="item.label">
                  <div @click="handleClickSelect(item)" :class="item.type == 'catalog' ? 'img2' : 'img'" :style="{
                    background: `url('${listData[item.key] && listData[item.key].find(item2 => item2.selected === true).fileImage
                      }') no-repeat center center /100% auto`,
                  }"></div>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </div>
      <div class="form-con tip-con"></div>
      <div class="boot">
        <el-button @click="prev">上一步</el-button>
        <el-button @click="preview" icon="el-icon-view" :loading="previewLoading">预览</el-button>
        <el-button type="primary" icon="el-icon-s-promotion" :loading="publishBtnLoading" @click="handlePublish(true)">
          确定发布
        </el-button>
      </div>
    </div>

    <el-dialog width="720px" :visible.sync="coverVisible" :title="coverTitle" :before-close="getClose">
      <div class="cover-list" v-if="activeKey !== 'catalogList'">
        <div class="cover" :key="'cover' + index" v-for="(cover, index) in listData[activeKey]">
          <template>
            <div v-if="cover.fileImage" :class="['img', { active: cover.selected && !selectShow }]"
              @click="handleSelectCover(cover)" :style="{
                background: `url('${cover.fileImage}') no-repeat center center /100% auto`,
              }"></div>
            <div class="name">{{ cover.documentName }}</div>
          </template>
        </div>
      </div>
      <div v-else class="cover-list">
        <div class="cover" :key="ind" v-for="(item, ind) in newList">
          <template>
            <div v-if="item.fileImage" :class="['img', { active: item.selected && !selectShow }]"
              @click="handleSelectCover(item)" :style="{
                background: `url('${item.fileImage}') no-repeat center center /100% auto`,
              }"></div>
            <div class="name">{{ item.documentName }}</div>
          </template>
        </div>
      </div>
      <!-- 上传目录页注释 -->
      <!-- <div v-if="activeKey === 'catalogList' && this.$route.params.fileType === '1'" class="upload_box">
        <div :class="!showBut ? 'noAll' : 'upimg'" @click="getfileUpdata">
          <input
            type="file"
            ref="inputImgFileUpdata"
            @change="onFileChangeUpdata"
            id="inputImgFileUpdata"
            style="display: none"
            accept="docx/*"
          />
          上传目录页
        </div>
      </div> -->
      <!--      上传之后的数据-->
      <div class="cover-list" v-if="updataList.length != 0">
        <div class="cover" v-for="(item, index) in updataList" :key="index">
          <div v-if="item.fileImage" :class="['img', { active: selectShow }]" @click="handleSelectItem" :style="{
            background: `url('${item.fileImage}') no-repeat center center /100% auto`,
          }">
            <i class="el-icon-error" @click="getDelete(item.id)"></i>
          </div>
          <div class="name">{{ item.documentName }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="getClose">取 消</el-button>
        <el-button type="primary" @click="confirmSelect">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="预览" width="50%" :visible="previewVisible" @close="closePreviewDialog" destroy-on-close>
      <div v-if="!previewUrl">
        <!--        <span>当前选取的素材总计{{ pages }}页，正在合成中....，预计耗时约5分钟，请稍候。</span>-->
        <span>合成中，请稍候...</span>
        <!--        <a href="javascript:void(0);" @click="previewVisible = false" style="text-decoration: none">【确认】</a>-->
      </div>
      <div v-else>
        <span>预览文件合成成功</span>
        <!--        <a target="_blank" :href="previewUrl" style="text-decoration: none" >【】</a>-->
        <!--        icon="el-icon-view"-->
        <el-button style="margin-left: 10px" @click="goToPreview(previewUrl)">前往预览</el-button>
        <el-button @click="handlePublish(false)">确定发布</el-button>
        <!--        <a href="javascript:void(0);" @click="handlePublish(false)" style="text-decoration: none">【确定发布】</a>-->
      </div>
    </el-dialog>
    <el-dialog title="发布" width="50%" :visible="publishVisible">
      <div>
        <span>合成中，请稍候...</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/pc/Breadcrumb";
import { confirm } from "@/utils/confirm";
import Fileupload from "@/components/pc/Fileupload";
import { tabPicture, tabDelete } from "@/api/getUpload";
import { numPage } from "@/api/queriesList";
const cacheName = "cacheDir";
const cacheMoveList = "moveList";
export default {
  name: "addCover",
  data() {
    return {
      publishVisible: false,
      fileImg: [],
      taskId: "",
      fodderData: [
        { key: "coverList", type: "cover", label: "封面页", pptxShow: true, wordShow: true },
        { key: "catalogList", type: "catalog", label: "目录页", pptxShow: true, wordShow: true },
        { key: "transitionList", type: "transition", label: "过渡页", pptxShow: true, wordShow: false },
        { key: "endList", type: "end", label: "封底页", pptxShow: true, wordShow: true },
      ],
      businessOpprtunityId: undefined,
      activeKey: "",
      coverVisible: false,
      listData: {},
      coverTitle: "选择标题",
      // currentPage: 0,
      // pageCount: 0,
      // loadedRatio: 0,
      // previewVisible: false,
      // previewLoading: false,
      cacheName: "",
      cacheMoveListName: "",
      fileType: "",
      previewVisible: false,
      previewUrl: "",
      timer: null,
      previewLoading: false,
      publishBtnLoading: false,
      publishLoading: false,
      updataList: [],
      selectShow: false,
      sid: null,
      showBut: true,
      idList: [],
      newList: [],
      numId: null,
      num: 0,
      pages: 0,
    };
  },
  components: {
    Breadcrumb,
    // pdf
  },
  computed: {
    selectCount() {
      let editdocStr = localStorage.getItem(this.cacheName);
      let editdocObj = JSON.parse(editdocStr);
      const canSelectCount = this.fodderData.filter(item =>
        this.fileType === 0 ? item.pptxShow : item.wordShow
      ).length;
      return editdocObj.selectedCount + canSelectCount;
    },
    showCatelog() {
      return item => {
        if (item.type === "catalog") {
          //判断里面有没有
          return !this.listData.catalogList?.some(obj => obj.fileImage.indexOf('目录页已上传') > -1)
        } else {
          return true
        }
      }
    }
  },
  beforeCreate() {
    document.body.setAttribute("style", "background:#F4F4F5");
    clearInterval(this.timer);
  },
  created() {
    this.taskId = this.$route.params.id;
    this.businessOpprtunityId = this.$route.params.did;
    this.fileType = Number(this.$route.params.fileType);
    this.getCoverList();
    this.cacheName = cacheName + this.businessOpprtunityId + "/" + this.taskId;
    this.cacheMoveListName = cacheMoveList + this.businessOpprtunityId + "/" + this.taskId;
  },
  methods: {
    // 关闭
    getClose() {
      this.coverVisible = false;
      this.selectShow = false;
      this.showBut = true;
      this.updataList = [];
      this.listData[this.activeKey].forEach(item => {
        if (this.num === 0) {
          if (item.id === this.numId) {
            item.selected = true;
          } else {
            // item.selected = false
          }
        }
      });
    },
    getDelete(id) {
      this.numId = id;
      tabDelete(id).then(res => {
        this.showBut = true;
        this.updataList = [];
        this.$message.success("删除成功");
        this.selectShow = false;
        this.listData[this.activeKey].forEach(item => {
          item.selected = false;
        });
        this.listData[this.activeKey][0].selected = true;
      });
    },
    // 上传图片
    getfileUpdata() {
      //console.log(123)
      const that = this;
      const inputImgFile = document.getElementById("inputImgFileUpdata");
      inputImgFile.click();
    },
    onFileChangeUpdata() {
      const fileInput = this.$refs.inputImgFileUpdata;
      const file = fileInput.files[0];
      var formData = new FormData();
      formData.append("file", file);
      tabPicture(formData)
        .then(res => {
          this.selectShow = true;
          this.showBut = false;
          this.updataList.push({
            documentName: res.data.documentName,
            fileImage: res.data.fileImage,
            filePath: res.data.filePath,
            fileUrl: res.data.fileUrl,
            id: res.data.id,
            type: res.data.type,
            selected: true,
          });
          fileInput.value = "";
        })
        .catch(error => {
          console.log(error);
        });
    },
    confirmSelect() {
      if (this.selectShow) {
        this.updataList.forEach(val => {
          this.idList.push(val.id);
          this.listData[this.activeKey].forEach(item => {
            item.selected = false;
          });
          this.listData[this.activeKey].push(val);
        });
      }
      this.num = 1;
      this.coverVisible = false;
    },
    handlePublish(isLoading) {
      let mergeData = this.getMergeData();
      this.publishBtnLoading = true;
      numPage(mergeData).then(r => {
        if (r.data) {
          this.pages = r.data;
          this.$request
            .getPreview(mergeData)
            .then(async res => {
              this.publishBtnLoading = false;
              if (!res.data || res.data.status === 1) {
                // await confirm(`您选取的素材总计有${r.data}页，预计耗时约5分钟进行页面合成，请确定是否发布`);
                await confirm(`请确定是否发布？`)
              }
              // else {
              //   await confirm(`您选取的素材总计有${this.selectCount}页，预计耗时约5分钟进行页面合成，请确定是否发布`)
              // }
              this.publishVisible = isLoading;
              this.publishLoading = isLoading;
              this.$request
                .publishDocument(mergeData)
                .then(res => {
                  localStorage.removeItem(this.cacheName);
                  this.$message.success("发布成功");
                  this.$router.push({
                    path: "/manage/doclist",
                    query: {
                      id: this.businessOpprtunityId,
                    },
                  });
                })
                .finally(_ => {
                  this.publishLoading = false;
                  this.publishVisible = false
                });
            })
            .finally(_ => {
              this.publishBtnLoading = false;
            });
        }
      });
    },
    getMergeData() {
      let editdocStr = localStorage.getItem(this.cacheName);
      let editdocObj = JSON.parse(editdocStr);
      const moveListStr = localStorage.getItem(this.cacheMoveListName);
      const moveList = JSON.parse(moveListStr);

      const data = {};
      data.hasDirectory = 0;
      // 判断是否已上传目录
      // 选中的文件的linkId
      data.selectedFodderIds = editdocObj.selectedFodderIds;
      if (this.fileType === 1) {
        if (moveList.some(item => item.name != "")) {
          data.hasDirectory = 1;
        } else {
          //没上传目录
          const defaultFolder = moveList.find(item => item.name == "");
          data.selectedFodderIds = defaultFolder.links.map(item => {
            return {
              id: null,
              name: item.fileName,
              links: [item.id],
            };
          });
        }
      }

      data.taskId = this.taskId;
      data.fileType = this.fileType;
      this.fodderData.forEach(item => {
        // 封面路径 目录路径 过渡页路径
        const selected = this.listData[item.key].filter(item => item.selected)[0];
        if (selected) {
          data[item.type + "Path"] = selected.filePath;
        }
      });
      const coverIndex = this.listData["coverList"].findIndex(item => item.selected);
      if (coverIndex < 0) {
        coverIndex = 0;
      }
      data.coverType = coverIndex + 1;
      return data;
    },
    handleSelectCover(cover) {
      this.selectShow = false;
      this.listData[this.activeKey].forEach(item => {
        item.selected = false;
      });
      cover.selected = true;
    },
    handleSelectItem() {
      this.selectShow = true;
    },
    handleClickSelect(fodderData) {
      this.newList = [];
      this.activeKey = fodderData.key;
      this.coverTitle = "选择" + fodderData.label;
      this.coverList = this.listData[fodderData.key];
      if (fodderData.key === "catalogList") {
        console.log(111);
        this.listData[this.activeKey].forEach(item => {
          if (this.idList.indexOf(item.id) == -1) {
            this.newList.push(item);
          } else {
            if (item.selected === true) {
              this.updataList.push(item);
              this.showBut = false;
              this.selectShow = true;
            }
          }
        });
        this.fodderData.forEach(val => {
          console.log(this.listData[val.key].length);
          if (this.listData[val.key].length !== 0) {
            console.log(this.listData[val.key].find(item => item.selected).fileImage);
          }
        });
      }
      this.num = 0;
      // debugger
      // if (fodderData.key !== "catalogList") {
      //   this.coverVisible = true;
      // }
      this.coverVisible = true;
    },
    getCoverList() {
      this.publishLoading = true;
      this.$request
        .getCoverList(this.fileType, this.taskId)
        .then(res => {
          // 设置默认选中第一个
          this.fodderData.forEach(item => {
            if (this.fileType === 0 ? item.pptxShow : item.wordShow) {
              res.data[item.key].forEach((item, index) => {
                if (index === 0) {
                  item.selected = true;
                } else {
                  item.selected = false;
                }
              });
            }
          });
          console.log(res.data);
          this.listData = res.data;
          this.activeKey = this.fodderData.find(item => (this.fileType === 0 ? item.pptxShow : item.wordShow)).key;
        })
        .finally(_ => {
          this.publishLoading = false;
        });
    },
    preview() {
      this.previewLoading = true;
      let mergeData = this.getMergeData();
      numPage(mergeData).then(r => {
        if (r.data) {
          this.pages = r.data;
          this.$request
            .getPreview(mergeData)
            .then(async res => {
              // 如果无数据 或 有预览失败的数据 则进行预览，
              this.previewLoading = false;
              if (!res.data || res.data.status === 1) {
                // await confirm(`您选取的素材总计有${r.data}页，预计耗时约5分钟进行页面合成，请确定是否进入预览`);
                await confirm(`请确定是否进入预览？`)
                this.previewVisible = true;
                this.$request.preview(mergeData).then(res => {
                  if (this.previewVisible) {
                    this.$message.success("预览素材合并完成");
                    this.previewUrl = res.data;
                  }
                });
              } else {
                this.previewVisible = true;
                if (res.data.status === 0) {
                  this.previewUrl = res.data.lxPreviewUrl;
                } else {
                  // 素材处于合并中状态 轮询查看是否合成完毕。
                  console.log("素材合并中，轮询查看是否合并完成");
                  this.timer = setInterval(() => {
                    this.$request.getPreview(mergeData).then(async res => {
                      if (res.data.status === 0 && this.previewVisible) {
                        this.$message.success("预览素材合并完成");
                        this.previewUrl = res.data.lxPreviewUrl;
                        clearInterval(this.timer);
                      }
                    });
                  }, 3000);
                }
              }
            })
            .finally(_ => {
              this.previewLoading = false;
            });
        }
      });
    },
    closePreviewDialog() {
      this.previewVisible = false;
      console.log("清空定时器");
      clearInterval(this.timer);
    },
    prev() {
      this.$router.go(-1);
    },
    goToPreview(url) {
      this.$openWindow(url);
    },
  },
};
</script>

<style lang="less" scoped>
.el-icon-error {
  position: relative;
  bottom: 9px;
  font-size: 20px;
  left: 191px;
}

.upload_box {
  margin: 20px 0px;
}

.upimg {
  width: 80px;
  line-height: 32px;
  background-color: #e60027;
  color: white;
  border-radius: 4px;
  text-align: center;
  padding: 0px 5px;
  cursor: pointer;
}

.noAll {
  width: 80px;
  line-height: 32px;
  background-color: #fab6b6;
  color: white;
  border-radius: 4px;
  text-align: center;
  padding: 0px 5px;
  cursor: not-allowed;
  pointer-events: none;
}

.form-con {
  margin: 0 156px;

  & .img {
    width: 180px;
    height: 102px;
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      border: 1px solid #e60027;
    }
  }

  & .img2 {
    width: 180px;
    height: 102px;
    border: 1px solid #ddd;
    border-radius: 8px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 30px;
  }

  ::v-deep .el-form-item__label {
    line-height: 14px;
    padding-bottom: 15px;
    font-weight: bold;
  }
}

::v-deep .el-dialog__body {
  padding-top: 0;
}

.tip-con {
  border-top: 1px solid #f5f5f5;
  margin-top: 24px;
  padding-bottom: 240px;

  &>.title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    padding: 15px 0;
  }

  &>.tip {
    color: rgba(0, 0, 0, 0.45);
    line-height: 30px;
  }
}

.cover-list {
  display: flex;
  flex-wrap: wrap;

  &>.cover {
    //flex: 0 0 200px;
    margin-right: 20px;

    &>.img {
      width: 200px;
      height: 120px;
      border: 1px solid #ddd;
    }

    &>.active {
      border: 1px solid #e60027;
    }

    &>.name {
      color: #ccc;
    }
  }
}
</style>
